import { render, staticRenderFns } from "./trendStatisticsType.vue?vue&type=template&id=ef7adc3a&scoped=true&"
import script from "./trendStatisticsType.vue?vue&type=script&lang=js&"
export * from "./trendStatisticsType.vue?vue&type=script&lang=js&"
import style0 from "./trendStatisticsType.vue?vue&type=style&index=0&id=ef7adc3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7adc3a",
  null
  
)

export default component.exports